module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant1_image-45c7df48da6b4fad9285760179fd5066.jpg";